var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.is_load
    ? _c(
        "div",
        {
          staticClass:
            "bg-gradient-primary user_profile bd-callout bd-callout-info position-relative px-2 p-1",
        },
        [
          _c("div", { staticClass: "d-flex flex-row pt-2 pb-1" }, [
            _c("span", { staticClass: "status" }, [
              parseInt(_vm.cur_user.id) > 0
                ? _c("picture", [
                    _c("source", {
                      attrs: {
                        srcset: _vm._f("get_image_from_template")(
                          _vm.user_avatar_template,
                          150,
                          150,
                          "webp"
                        ),
                        type: "image/webp",
                      },
                    }),
                    _vm._v(" "),
                    _c("source", {
                      attrs: {
                        srcset: _vm._f("get_image_from_template")(
                          _vm.user_avatar_template,
                          150,
                          150,
                          "png"
                        ),
                        type: "image/png",
                      },
                    }),
                    _vm._v(" "),
                    _c("img", {
                      staticClass:
                        "profile-image rounded-circle d-inline-block cursor-pointer",
                      attrs: {
                        src: _vm._f("get_image_from_template")(
                          _vm.user_avatar_template,
                          150,
                          150,
                          "png"
                        ),
                      },
                      on: { click: _vm.show_profile },
                    }),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "user_attrib ml-3" }, [
              _c("div", { staticClass: "name d-block fw-700 text-dark" }, [
                _vm._v(_vm._s(_vm.user_name)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "company small text-dark" }, [
                _vm._v(_vm._s(_vm.user_company)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "dolznost small text-dark" }, [
                _vm._v(_vm._s(_vm.user_dolznost)),
              ]),
              _vm._v(" "),
              _vm.is_user_name_redirect
                ? _c("span", { staticClass: "small fw-700 text-dark" }, [
                    _vm._v(_vm._s(_vm.user_name_redirect_output)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.show_vacation
                ? _c(
                    "div",
                    { staticClass: "vacation" },
                    [
                      _c("vacation", {
                        attrs: { id: parseInt(this.u_user.id) },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ]),
          _vm._v(" "),
          _vm.can_del
            ? _c(
                "span",
                {
                  staticClass:
                    "rem_user_ins btn btn-icon btn-sm btn-danger shadow waves-effect waves-themed cursor-pointer",
                  on: { click: _vm.close },
                },
                [_c("i", { staticClass: "fal fa-times" })]
              )
            : _vm._e(),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }